export const ICON_SIZE_IN_PIXEL = 16;
export const DEFAULT_WA_LABEL = 'WhatsApp';
export const DEFAULT_MESSENGER_LABEL = 'Messenger';
export const DEFAULT_SMS_LABEL = 'SMS';
